import { isTestcafeEnabled } from '@/services/testCafe';
import type { ApiEndpoints } from '@/types/backend';

type Params = Record<string, any>

class Endpoints {
    private readonly apiPrefix: string;

    constructor () {
        this.apiPrefix = isTestcafeEnabled()
            ? process.env.VUE_APP_API_BASE_TESTCAFE_URL
            : process.env.VUE_APP_API_BASE_URL;

        this.apiPrefix += 'v1/';
    }

    get (endpointLabel: ApiEndpoints, params?: Params): string {
        let url = endpointLabel as string;

        if (typeof params === 'object') {
            Object.keys(params).forEach((param) => {
                url = url.replace(`:${param}`, params[param]);
            });
        } else if (url.indexOf('/:') > 0) {
            url = url.substring(0, url.indexOf('/:'));
        }

        return this.apiPrefix.concat(url);
    }
}

export default new Endpoints();
